import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export function Topbar() {
  const { profile, signOut } = useAuth()
  return (
    <>
      <a href="#main-content" className="skip-to-main">Skip to main content</a>
      <header className="topbar" role="banner">
        <Link to="/" className="topbar-brand" aria-label="Loan Closing Agent LLC - Home" style={{ display:'inline-flex', alignItems:'center' }}>
          <span style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', width:54, height:54, borderRadius:'50%', border:'1px solid rgba(201,168,76,0.4)' }}>
            <img
              src="/lca_logo_quill_map.png"
              alt="Loan Closing Agent LLC - Nationwide Notary Professionals Network"
              style={{ width:48, height:48, objectFit:'contain', display:'block' }}
            />
          </span>
        </Link>
        <div className="topbar-right">
          <span style={{ fontSize:13, color:'rgba(255,255,255,0.6)' }} aria-label={`Signed in as ${profile?.full_name}`}>{profile?.full_name}</span>
          <button onClick={signOut} className="btn btn-sm" aria-label="Sign out of your account" style={{ background:'rgba(201,168,76,0.15)', color:'#C9A84C', border:'1px solid rgba(201,168,76,0.3)', fontSize:12 }}>
            Sign out
          </button>
        </div>
      </header>
    </>
  )
}

export function Sidebar({ items }) {
  const loc = useLocation()

  function isActive(item) {
    // ✅ Exact match for dashboard-style routes (end:true)
    if (item.end) return loc.pathname === item.to
    // Otherwise match exact OR child routes
    return loc.pathname === item.to || loc.pathname.startsWith(item.to + '/')
  }

  return (
    <nav className="sidebar" role="navigation" aria-label="Main navigation">
      {items.map((item, i) => (
        item.section
          ? <div key={i} className="sidebar-section" role="heading" aria-level="3">{item.section}</div>
          : <Link key={i} to={item.to}
              className={`sidebar-item ${isActive(item) ? 'active' : ''}`}
              aria-current={isActive(item) ? 'page' : undefined}>
              <span className="sidebar-icon" aria-hidden="true">{item.icon}</span>
              {item.label}
              {item.badge > 0 && (
                <span
                  className="sidebar-badge"
                  aria-label={`${item.badge} new`}
                  style={{
                    marginLeft: 8,
                    background: '#E24B4A',
                    color: '#fff',
                    fontSize: 11,
                    fontWeight: 700,
                    minWidth: 18,
                    height: 18,
                    borderRadius: 9,
                    padding: '0 5px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1,
                    verticalAlign: 'middle',
                  }}>
                  {item.badge > 99 ? '99+' : item.badge}
                </span>
              )}
            </Link>
      ))}
    </nav>
  )
}

export function PortalLayout({ sidebarItems, children }) {
  return (
    <>
      <Topbar />
      <div className="app-layout">
        <Sidebar items={sidebarItems} />
        <main className="main-content" id="main-content" role="main" tabIndex="-1">
          {children}
        </main>
      </div>
    </>
  )
}
